import React from 'react';
import { useSelector } from 'react-redux';
import cN from 'classnames';
import { RootState } from '@Redux/detail/store';
import { I_RecommendList } from '@Redux/detail/Recommend/reducer';
import RecommendCard from '@components/DetailPage/RecommendCard';
import Explain from './subComponents/Explain';
import styles from './styles.module.scss';
import domainByEnv from '@utils/domainByEnv';
import { useMediaQuery } from 'react-responsive';

interface I_Props {
    storyData?: {
        currentData: I_RecommendList;
        recommendList: I_RecommendList[];
    };
}

const RecommendCards: React.FC<I_Props> = ({ storyData }) => {
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });
    const recommends = useSelector((state: RootState) => state.recommendReducer);

    const showColumns = () => {
        // 最多顯示 3 筆資料
        if (Array.isArray(recommends?.recommendList)) {
            const columns = recommends?.recommendList?.map(
                (recommend: I_RecommendList, i: number) => {
                    const currentRecommendsData = {
                        ImgUrl: recommend.ImgM,
                        ProductType: recommend.ProductType,
                        TourName: recommend.TourName,
                        TourDays: recommend.TourDays,
                        Airline: recommend.GroupList[0].AirLine,
                        Price: recommend.GroupStraightPrice,
                        TripTypeList: recommend.TripTypeList,
                        TagList: recommend.TagList,
                        Route: `${domainByEnv()}/detail?NormGroupID=${
                            recommend.NormGroupID
                        }&GroupID=${recommend.GroupList[0].GroupID}`,
                        Status: recommend.Status,
                        currency:
                            recommend.GroupList.length > 0
                                ? recommend.GroupList[0].CurrencyCode
                                : '',
                    };

                    if (isMobile) {
                        // M 版顯示前 10 筆資料
                        if (i < 10)
                            return <RecommendCard key={i} {...currentRecommendsData} index={i} />;
                    } else {
                        // PC 版顯示前 4 筆資料
                        if (i < 4)
                            return <RecommendCard key={i} {...currentRecommendsData} index={i} />;
                    }
                }
            );

            // 不到 3 筆顯示 "查看更多"
            while (columns.length < 4) {
                columns.push(<RecommendCard key={columns.length + 1} />);
            }

            return columns;
        }
    };

    return (
        <div className={cN(styles.container, 'recommend_cards')}>
            <div className={styles.scrollArea}>
                <Explain />
                {showColumns()}
            </div>
        </div>
    );
};

export default RecommendCards;
